import { LoanStatus } from '@willow/types-iso';

export function isValidLoanStatusChange(
  status: LoanStatus,
  newStatus: LoanStatus,
  hasUntrackedPayoff: boolean,
  hasActiveBankruptcy: boolean,
): boolean {
  switch (status) {
    case 'preActive':
    case 'active':
      return hasActiveBankruptcy ? ['active', 'pendingTransfer', 'paidOff', 'archived'].includes(newStatus) : true; // All options allowed
    case 'archived':
      return ['active'].includes(newStatus);
    case 'pendingActivation':
      return ['active', 'preActive', 'archived'].includes(newStatus);
    case 'pendingTransfer':
      return ['preActive', 'active', 'transferred', 'paidOff'].includes(newStatus);
    case 'transferred':
      return ['archived'].includes(newStatus);
    case 'paidOff':
      // allow untracked payoffs to be reverted to active status
      const allowedStatuses = hasUntrackedPayoff ? ['active', 'archived'] : ['archived'];
      return allowedStatuses.includes(newStatus);
    case 'reo':
      // Note: there is future work needed when changing from reo to active status (i think its for reporting purposes?)
      // but while we were previously blocking this behavior in reality, we were just doing manual loan surgery to update the status
      return ['liquidated', 'archived', 'active'].includes(newStatus);
    case 'liquidated':
      return ['active'].includes(newStatus); // Followup i11030 - add support for restoring to prior status
    default:
      return false;
  }
}

export function shouldRescindGoodbye(oldStatus: LoanStatus, newStatus: LoanStatus): boolean {
  return (oldStatus === 'pendingTransfer' || oldStatus === 'transferred') && ['active', 'paidOff'].includes(newStatus);
}
